var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles.col},[_c('div',{staticClass:"term-box",class:{ active: _vm.active }},[_vm._t("text"),_vm._v(" "),_vm._t("price"),_vm._v(" "),_vm._t("subtext"),_vm._v(" "),_vm._t("reccomended")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }